import { Skeleton } from '@/components/ui/skeleton';
import { useFollowUpSettings, useSaveFollowUpSettings } from '@/hooks/queries';
import { FollowUpSettingsForm } from './FollowUpSettingsForm';
import { FundraisingPage } from './FundraisingPage';

/**
 * The Fundraiser's follow-up settings page: the eight drafts callers send during and after a call, and where
 * {link} points. Callers' phones pick up a save on their next drafts fetch — no app release.
 */
export function FollowUpSettingsEditor() {
  const { data, isLoading, isError } = useFollowUpSettings();
  const { mutate: save, isPending, error } = useSaveFollowUpSettings();

  return (
    <FundraisingPage tab="follow-ups">
    <div className="max-w-5xl space-y-6">
      <div>
        <p className="text-[13px] text-muted-foreground">
          The texts and emails callers send from their own phone during and after a call. Use {'{first_name}'},{' '}
          {'{amount}'}, {'{link}'} and {'{candidate}'} to make each one personal.
        </p>
      </div>

      {isLoading && (
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-40 w-full" />
          ))}
        </div>
      )}
      {isError && !isLoading && (
        <p className="text-sm text-muted-foreground">We couldn&apos;t load the follow-up settings right now.</p>
      )}
      {data && (
        // Remount on each saved version so the form shows the server's copy and sends the fresh token.
        <FollowUpSettingsForm
          key={data.concurrencyVersion}
          settings={data}
          onSave={(request) => save(request)}
          saving={isPending}
          error={error?.message ?? null}
        />
      )}
    </div>
    </FundraisingPage>
  );
}
